const data = [
  {
    home_page: {
      title:
        "Home - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED | Chennai’s Leading Game & App Development Company",
      meta: {
        meta1: {
          name: "description",
          content:
            "Welcome to SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED – Chennai’s premier game, software, and mobile app development company. We specialize in Unity games, AR/VR, training, and full-stack development.",
        },
      },
    },
    about_page: {
      title:
        "About Us - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED | Empowering Developers & Innovators Since 2020",
      meta: {
        meta1: {
          name: "description",
          content:
            "Based in Chennai, SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED has trained 2,000+ students and delivered 100+ successful projects in gaming, software, and mobile apps.",
        },
      },
    },
    services_page: {
      title:
        "Services - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED | Game, Web, App & Software Development in Chennai",
      meta: {
        meta1: {
          name: "description",
          content:
            "Explore SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED’ end-to-end IT services including game design, website development, app creation, AR/VR solutions, digital marketing, and enterprise software.",
        },
      },
    },
    services_page_software: {
      title: "Custom Software Development - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED | Chennai",
      meta: {
        meta1: {
          name: "description",
          content:
            "Custom ERP, CRM, billing and automation tools developed by our software experts in Chennai using modern tech stacks.",
        },
      },
    },
    services_page_casino: {
      title: "Casino & Sportsbook Development - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED",
      meta: {
        meta1: {
          name: "description",
          content:
            "Get custom-built casino and sportsbook platforms with real-time odds, payment integrations, and player analytics.",
        },
      },
    },
    services_page_Gamedevelopment: {
      title: "Game Development Services - Unity & 3D Gaming Experts in Chennai",
      meta: {
        meta1: {
          name: "description",
          content:
            "Design, develop, and launch 2D, 3D, and multiplayer games for Android, iOS, and PC with our game studio in Chennai.",
        },
      },
    },
    services_page_Devops: {
      title: "DevOps Services - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED | CI/CD, Docker, AWS Experts",
      meta: {
        meta1: {
          name: "description",
          content:
            "Streamline development and deployment with our DevOps services including CI/CD, Docker, Jenkins, Kubernetes, and cloud solutions.",
        },
      },
    },
    services_page_AR_VR: {
      title: "AR/VR Development - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED | Immersive Experience Designers",
      meta: {
        meta1: {
          name: "description",
          content:
            "Build custom AR/VR experiences for learning, marketing, gaming, or simulation using the latest immersive technologies.",
        },
      },
    },
    services_page_IT_Support: {
      title: "Managed IT Support - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED | Chennai",
      meta: {
        meta1: {
          name: "description",
          content:
            "We provide managed IT support services including system setup, troubleshooting, networking, and cybersecurity solutions.",
        },
      },
    },
    services_page_Website_Developmet: {
      title:
        "Website Development - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED | Responsive & SEO-Friendly Websites",
      meta: {
        meta1: {
          name: "description",
          content:
            "Professional websites built using React, WordPress, HTML/CSS with SEO optimization and lightning-fast performance.",
        },
      },
    },
    services_page_Training_Program: {
      title:
        "IT Training Programs - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED | Learn Full Stack, Game Dev & AR/VR",
      meta: {
        meta1: {
          name: "description",
          content:
            "Project-based training with certification in web development, Unity 3D, React, Flutter, Python, and digital marketing.",
        },
      },
    },
    services_page_App_Development: {
      title:
        "Mobile App Development - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED | Android & iOS Apps in Chennai",
      meta: {
        meta1: {
          name: "description",
          content:
            "We build fast, secure, and scalable Android/iOS apps using React Native, Flutter, and native technologies.",
        },
      },
    },
    services_page_Digital_Marketing: {
      title:
        "Digital Marketing Services - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED | SEO, SMM, Ads & Branding",
      meta: {
        meta1: {
          name: "description",
          content:
            "Grow your brand online with our SEO, content marketing, Google Ads, and social media strategies.",
        },
      },
    },
    services_page_Technologies: {
      title: "Technologies - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED | Full Stack, Unity, AWS & More",
      meta: {
        meta1: {
          name: "description",
          content:
            "Explore the modern technologies we use: React, Node.js, Unity, Firebase, Docker, MongoDB, and cloud platforms.",
        },
      },
    },
    services_page_Portfolio: {
      title: "Portfolio - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED | Game, Web & App Projects",
      meta: {
        meta1: {
          name: "description",
          content:
            "Browse through our diverse portfolio of successful Unity games, mobile apps, websites, and training projects.",
        },
      },
    },
    technology_page: {
      title: "Technology - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED",
      meta: {
        meta1: {
          name: "description",
          content:
            "Get professionally tailored solutions using the latest tech stack including JavaScript, Python, Unity, and AWS.",
        },
      },
    },
    portfolio_page: {
      title: "Portfolio - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED",
      meta: {
        meta1: {
          name: "description",
          content:
            "Discover our real-time projects built for gaming, education, healthcare, and enterprise across multiple platforms.",
        },
      },
    },
    trainings_page: {
      title: "Training - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join our real-time internship & training programs with placement support. Learn to build complete projects from scratch.",
        },
      },
    },

    blog_page: {
      title:
        "Blog - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED | Chennai’s Leading Game & App Development Company",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join our real-time internship & training programs with placement support. Learn to build complete projects from scratch.",
        },
      },
    },

    blog_page_subpage1: {
      title:
        "Blog - Unity Solution | Chennai’s Leading Game & App Development Company",
      meta: {
        meta1: {
          name: "description",
          content:
            "Join our real-time internship & training programs with placement support. Learn to build complete projects from scratch.",
        },
      },
    },
    contactus_page: {
      title: "Contact Us - SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED",
      content:
        "Ready to start your journey with us? We're here to help you choose the right course.",
      meta: {
        meta1: {
          name: "description",
          content:
            "Reach out to SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED, Chennai’s leading tech institute and software company for development, training, or support.",
        },
      },
    },
    cookieContent:
      "We use our own cookies for the use of the rolling energy site, personalize content and perform analyses of our traffic. We also share information about your use of our site with analytics partners who may combine it with other information that you’ve provided to them or that they’ve collected from your use of their services.",
  },
];

export default data;
